import { useMemo } from 'react';
import { DomainOrderResponseDto } from '@tiendanube/common';
import { DomainOrderStatus } from '@tiendanube/common/src/domains/nuvem-domains/types';
import {
  DOMAIN_LIFECYCLE_PENDING_VERIFICATION_STATUSES,
  DOMAIN_ORDER_PROCESSING_STATUSES,
  DOMAIN_ORDER_PURCHASE_ERROR_STATUSES,
  DOMAIN_ORDER_REDIRECT_TO_LIST_STATUSES,
} from '../../constants';

export const pendingVerificationStates =
  DOMAIN_LIFECYCLE_PENDING_VERIFICATION_STATUSES;

export type OrderState = 'pending' | 'error' | 'success' | 'redirect' | 'idle';

export const pendingStates = DOMAIN_ORDER_PROCESSING_STATUSES;

export const errorStates = DOMAIN_ORDER_PURCHASE_ERROR_STATUSES;

export const redirectStates = DOMAIN_ORDER_REDIRECT_TO_LIST_STATUSES;

export const useOrderState = (orderData?: DomainOrderResponseDto): OrderState =>
  useMemo(() => {
    if (!orderData) {
      return 'idle';
    }

    if (orderData.acknowledged || redirectStates.includes(orderData.status)) {
      return 'redirect';
    }

    if (pendingStates.includes(orderData.status)) {
      return 'pending';
    }

    if (errorStates.includes(orderData.status)) {
      return 'error';
    }

    if (orderData.status === DomainOrderStatus.PURCHASED) {
      return 'success';
    }

    return 'error';
  }, [orderData]);
